import { Box, Card, Typography } from "@mui/material";

/** White rounded card with a title row. The basic building block of every page. */
export default function SectionCard({ title, subtitle, action, children, sx, contentSx }) {
  return (
    <Card sx={{ p: { xs: 2, md: 3 }, ...sx }}>
      {(title || action) && (
        <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2, mb: 2 }}>
          <Box>
            {title && <Typography variant="h6">{title}</Typography>}
            {subtitle && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {action}
        </Box>
      )}
      <Box sx={contentSx}>{children}</Box>
    </Card>
  );
}
